module.exports = __webpack_public_path__ + "static/media/menu-button.50abf686.svg";